// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2aTDc","dragIcon":"SortableItem_dragIcon__1JR7m","disabled":"SortableItem_disabled__1y_5S"};